import messages from '../messages';
import {
  Input,
  Box,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import { DatePicker } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import React, { useState } from 'react';
import useIntl from '../../../hooks/useIntl';
import moment from 'moment';
import { toastr } from 'react-redux-toastr';
import { rentForecastExist } from '../utils';

const RentForecastModal = (props) => {
  const { closeModal, createRentForecast, isLoading, open, rentForecastsData } =
    props;
  const [rentForecastValues, setRentForecastValues] = useState({
    name: '',
    date: null,
  });
  const intl = useIntl();

  const handleSubmit = () => {
    const data = {
      name: rentForecastValues.name.trim(),
      year: rentForecastValues.date.year(),
    };

    if (
      rentForecastExist(data.name, data.year, rentForecastsData.rentForecasts)
    ) {
      toastr.error(
        intl.formatMessage(messages.error),
        intl.formatMessage(messages.forecastDuplicateError),
        { timeOut: 0, showCloseButton: true },
      );
      return;
    }

    createRentForecast(data, {
      onSuccess: () => {
        closeModal();
        setRentForecastValues({
          name: '',
          date: null,
        });
      },
    });
  };

  const handleChange = (name, value) => {
    if (name === 'date') {
      const date = moment(value).startOf('year');
      setRentForecastValues((prev) => ({
        ...prev,
        [name]: date,
      }));
    } else {
      setRentForecastValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const { name, date } = rentForecastValues;

  return (
    <Modal
      open={open}
      onClose={closeModal}
      title={intl.formatMessage(messages.newRentForecast)}
      actionsProps={[
        {
          children: 'Cancel',
          onClick: closeModal,
        },
        {
          children: 'Save',
          submitButton: true,
          isSubmitting: isLoading,
          onClick: handleSubmit,
          disabled: !name.trim() || !date,
        },
      ]}
      ModalProps={{
        PaperProps: {
          sx: {
            width: {
              xs: 'calc(100% - 32px)',
              sm: 480,
            },
            maxHeight: 'calc(100vh - 100px)',
          },
        },
      }}
    >
      <Box sx={{ display: 'flex', gap: 3 }}>
        <Input
          label={intl.formatMessage(messages.name)}
          placeholder={intl.formatMessage(messages.placeholder)}
          onChange={(e) => handleChange('name', e.target.value)}
          required
          value={name}
        />
        <DatePicker
          label={intl.formatMessage(messages.date)}
          placeholder={intl.formatMessage(messages.datePlaceholder)}
          onChange={(date) => handleChange('date', date)}
          required
          value={date}
          views={['year']}
        />
      </Box>
    </Modal>
  );
};

export default RentForecastModal;
